import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [<>
      Empiezas a tejer… pero abandonas porque <b data-id="element-136">no entiendes los patrones</b>
    </>, <>
      Pasas horas buscando tutoriales y <b data-id="element-137">terminas más confundida</b>
    </>, <>
      Sientes que esto no es para ti, <i data-id="element-138">aunque te encanta</i>
    </>, <>
      Ves cosas hermosas en Pinterest pero <b data-id="element-139">no sabes cómo hacerlas</b>
    </>];
  return <section className="w-full py-20 px-4 bg-cream" data-id="element-140">
      <div className="max-w-3xl mx-auto" data-id="element-141">
        <h2 className="font-heading font-bold text-3xl md:text-5xl text-center text-textDark mb-16" data-id="element-142">
          ¿Te pasa esto?
        </h2>

        <div className="grid gap-4 mb-16" data-id="element-143">
          {problems.map((problem, index) => <div key={index} className="flex items-center gap-5 p-6 bg-white rounded-2xl shadow-soft border border-secondary/50 transition-transform hover:-translate-y-1 duration-300" data-id="element-144">
              <div className="bg-urgency/10 p-3 rounded-full flex-shrink-0" data-id="element-145">
                <XCircleIcon className="w-6 h-6 text-urgency" aria-hidden="true" data-id="element-146" />
              </div>
              <p className="font-body text-lg text-textDark leading-relaxed" data-id="element-147">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="text-center relative" data-id="element-148">
          {/* Decorative line */}
          <div className="absolute top-1/2 left-0 w-full h-px bg-secondary -z-10" data-id="element-149"></div>

          <div className="inline-block bg-cream px-8 py-6 rounded-3xl border border-secondary shadow-sm" data-id="element-150">
            <p className="font-heading text-2xl md:text-3xl text-primary font-bold italic mb-3" data-id="element-151">
              👉 No es tu culpa…
            </p>
            <p className="font-body text-lg md:text-xl text-textDark" data-id="element-152">
              El problema es que <u data-id="element-153">nadie te enseñó de forma simple</u>.
            </p>
          </div>
        </div>
      </div>
    </section>;
}